/** Why a Sending run still has recipients it has not handed to the sender. */
export enum NewsletterSendHoldReason {
  // Nothing holds them back — a Resume sends now (a warm-up run parks tomorrow's batch this way).
  None = 0,
  DomainBlocked = 1,
  BouncePaused = 2,
}
